var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, createContext, useContext } from 'react';
import styled from 'styled-components';
import { MIN_CELL_WIDTH } from "../../helpers";
import { GridContext } from './GridProvider';
var ResizeIndicator = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    border-right: 1px solid ", ";\n\n    transform: translate3d(0, 0, 0);\n    visibility: hidden;\n"], ["\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    border-right: 1px solid ", ";\n\n    transform: translate3d(0, 0, 0);\n    visibility: hidden;\n"])), function (props) { return props.theme.colorHighlightDark; });
export var GridResizableContext = createContext({
    onResizeToggleDown: function () { }
});
export var useGridResizableContext = function () { return useContext(GridResizableContext); };
export var resizeIndicatorId = 'grid-resize-indicator';
var GridResizable = /** @class */ (function (_super) {
    __extends(GridResizable, _super);
    function GridResizable(props) {
        var _this = _super.call(this, props) || this;
        _this.onMouseDown = function (e, activeColumn) {
            e.preventDefault();
            var pageX = e.pageX;
            var layoutRef = _this.props.layoutRef;
            var indicatorRef = _this.indicatorRef;
            if (layoutRef.current && indicatorRef.current) {
                _this.layoutRect = layoutRef.current.getBoundingClientRect();
                layoutRef.current.style.cssText = 'user-select: none';
                _this.startX = pageX;
                _this.activeColumn = activeColumn;
                indicatorRef.current.style.cssText = "transform: translate3d(" + (pageX -
                    _this.layoutRect.left) + "px, 0, 0); visibility: visible;";
                document.addEventListener('mousemove', _this.onMouseMove);
                document.addEventListener('mouseup', _this.onMouseUp, { once: true });
            }
        };
        _this.onMouseMove = function (e) {
            e.preventDefault();
            var _a = _this, layoutRect = _a.layoutRect, indicatorRef = _a.indicatorRef;
            if (!layoutRect || !_this.startX) {
                return;
            }
            var shift = e.pageX - layoutRect.left;
            var cssText = _this.getStyleForIndicatorOnMove(shift, layoutRect.width);
            requestAnimationFrame(function () {
                if (indicatorRef.current) {
                    indicatorRef.current.style.cssText = cssText;
                }
            });
        };
        _this.onMouseUp = function (e) {
            var _a;
            e.preventDefault();
            var pageX = e.pageX;
            var _b = _this.props, layoutRef = _b.layoutRef, onColumnResize = _b.onColumnResize;
            var updateResizedColumns = _this.context.updateResizedColumns;
            var _c = _this, startX = _c.startX, layoutRect = _c.layoutRect, activeColumn = _c.activeColumn, indicatorRef = _c.indicatorRef;
            if (startX && layoutRect && activeColumn) {
                var delta = startX - pageX;
                var width = Math.max(Math.floor(activeColumn.width - delta), activeColumn.minWidth || MIN_CELL_WIDTH);
                var shift = e.pageX - layoutRect.left;
                if (shift > 0 && shift < layoutRect.width) {
                    updateResizedColumns((_a = {},
                        _a[activeColumn.key] = width,
                        _a));
                    onColumnResize === null || onColumnResize === void 0 ? void 0 : onColumnResize({
                        prevWidth: activeColumn.width,
                        width: width,
                        columnId: activeColumn.columnId
                    });
                }
                _this.activeColumn = null;
                _this.startX = null;
                _this.layoutRect = null;
                document.removeEventListener('mousemove', _this.onMouseMove);
                document.removeEventListener('mouseup', _this.onMouseUp);
                requestAnimationFrame(function () {
                    if (indicatorRef.current && layoutRef.current) {
                        indicatorRef.current.removeAttribute('style');
                        layoutRef.current.removeAttribute('style');
                    }
                });
            }
        };
        _this.indicatorRef = React.createRef();
        _this.activeColumn = null;
        _this.startX = null;
        _this.layoutRect = null;
        return _this;
    }
    GridResizable.prototype.getStyleForIndicatorOnMove = function (shift, width) {
        if (shift > 0 && shift < width) {
            return "transform: translate3d(" + shift + "px, 0, 0); visibility: visible;";
        }
        return 'visibility: hidden;';
    };
    GridResizable.prototype.render = function () {
        var _a = this.context.state, resizable = _a.resizable, disabled = _a.disabled;
        var children = this.props.children;
        return (React.createElement(GridResizableContext.Provider, { value: {
                onResizeToggleDown: this.onMouseDown
            } },
            children,
            resizable && !disabled && (React.createElement(ResizeIndicator, { "data-selector-id": resizeIndicatorId, ref: this.indicatorRef }))));
    };
    return GridResizable;
}(Component));
GridResizable.contextType = GridContext;
export default GridResizable;
var templateObject_1;
//# sourceMappingURL=GridResizable.js.map